<template>
  <div class="main" id="top">

    <div class="content">
      <Header></Header>
      <!-- <div class="part11"> -->
      <div class="part1">
        <div class="part1_font">
          <div class="part1_font1">
            清耳话声
          </div>
          <div class="part1_font1">
            耳鸣康复治疗仪
          </div>
        </div>
        <div class="part1_font_1">
          <div>
            官方价￥<span class="part1_font_1_1">{{ price }}</span>
          </div>
        </div>
        <div class="bugBtn">
          <van-button @click="goPay" round color="#733d9a">购买</van-button>
        </div>
        <div class="part1_img">
          <img style="width: 100vw;;" src="./image/2.png"></img>
        </div>

        <div class="regCode"> <el-row>
            <el-col style="text-align: right" :span="12">医疗器械注册证编号：</el-col>
            <el-col style="text-align: left" :span="12">苏械注准20222191488</el-col>
          </el-row>
          <el-row>
            <el-col style="text-align: right" :span="12">医疗器械生产许可证编号：</el-col>
            <el-col style="text-align: left" :span="12">苏药监械生产许20220242号</el-col>
          </el-row>
        </div>
      </div>
      <!-- </div> -->

      <div class="part2">
        <div class="part2_font1">
          产品介绍
        </div>
        <div class="part2_font2">
          <div style="font-weight: 550;">清耳话声“耳鸣康复治疗仪”获得</div>
          <div class="part2_font3">
            <div style="font-weight: 550;">
              2022年日内瓦国际发明金奖<br>2020年全国发明金奖
            </div>
            <div>
              国家二类医疗器械注册证书和生产许可证书
            </div>
            <div>
              发明专利和软件著作权20余项
            </div>
            <div>
              通过中国电子学会科技成果鉴定
            </div>
          </div>
        </div>


        <div class="part1_img">
          <img style="width: 75vw;" src="./image/3.png"></img>
        </div>
      </div>
      <div class="part3">
        <div class="part2_font1">
          治疗原理
        </div>

        <div style="margin-top: 3vh;" class="part3_content">
          <img class="part3_img" src="./image/4.png"></img>
          <img class="part3_img" style="width:90%" src="./image/5.png"></img>
          <div class="part3_font">
            将音乐中以耳鸣频率为中心的一段频率移除，从而制成有切迹的音乐。目的是激活耳鸣频率附近的听皮层神经活动，抑制切迹范围内频率对应的听皮层神经活动，产生侧抑制效果，从而促进听皮层特定区域的重塑，减弱耳鸣活动及其相关感知。
          </div>
        </div>
        <div class="part3_content">
          <img class="part3_img" src="./image/6.png"></img>
          <img class="part3_img" style="width:90%" src="./image/7.png"></img>
          <div class="part3_font">
            通过外界给予与损伤部分毛细胞相对应的宽带或窄带噪声为掩蔽声，抑制耳蜗或蜗神经的自发性兴奋增强的活动，降低异常自发放电活动，从而达到减轻或消除耳鸣的目的。
          </div>
        </div>

      </div>


      <div class="part41">
        <div class="part4">
          <div class="part2_font1">
            产品特点
          </div>



          <div class="part4ContextBox" style="text-align: center">
            <div>
              <img style="width: 100px;margin: 5px" src="./image/8.png"></img>
            </div>
            <div style="text-align: center;align-content: center;
  margin: auto;">
              <div class="part4Font">
                全球首创集耳鸣精准检测✚个性化智能音乐治疗于一体的便携式医疗器械，您的专属耳鸣治疗仪。
              </div>
            </div>
          </div>

          <div class="part4ContextBox">
            <div>
              <img style="width: 100px;margin: 5px" src="./image/9.png"></img>
            </div>
            <div style="text-align: center;align-content: center;
  margin: auto;">
              <div class="part4Font">
                技术源于清华，根据耳鸣症状，对症用“乐”，个性化、精准定量的音乐治疗方案，安全、有效解决耳鸣痛苦。
              </div>
            </div>
          </div>

          <div class="part4ContextBox">
            <div>
              <img style="width: 100px;margin: 5px" src="./image/10.png"></img>
            </div>
            <div style="text-align: center;align-content: center;
  margin: auto;">
              <div class="part4Font" style="margin: auto">
                高性能设备加创新性算法，选用大动态范围、高频响硬件+经过校准的专业定制声学耳机，解决了高频耳鸣无法治愈的国际难题，为耳鸣患者尤其是高频耳鸣患者的康复带来福音。
                中国电子学会科技成果鉴定：“原创性地提出了针对高频耳鸣的对数能量均衡技术，实现了对高频耳鸣的有效治疗”。
              </div>
            </div>
          </div>


          <div class="part4ContextBox">
            <div>
              <img style="width: 100px;margin: 5px" src="./image/11.png"></img>
            </div>
            <div style="text-align: center;align-content: center;
  margin: auto;">
              <div class="part4Font" style="margin: auto">
                体积小巧便携、功能强大，避免多次往返医院。
              </div>
            </div>
          </div>


          <div class="part4ContextBox" style="margin-bottom: 20px">
            <div>
              <img style="width: 100px;margin: 5px" src="./image/12.png"></img>
            </div>
            <div style="text-align: center;align-content: center;
  margin: auto;">
              <div class="part4Font">
                首创基于中枢机理的全自然音乐背景治疗耳鸣，轻松悦耳又舒适。
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer></Footer>
    </div>


    <van-popup v-model="showFocus" position="bottom" :style="{ height: '20%' }">
      <div class="foucsContent">
        <div class="foucsFont1"> <van-icon name="checked" /> 支付成功</div>
        <div class="foucsFont2">关注公众号可查看购买记录，为了更好的为您提供专业服务，请在公众号中下载APP进行注册。</div>
        <div class="foucsFont3"> <van-button @click="goFouces" @closed="onCencelFouces" round
            color="#733d9a">立即关注</van-button> </div>
      </div>

    </van-popup>

    <a class="bootom_right" href="https://work.weixin.qq.com/kfid/kfce77bbcf05520b533">
      <el-image style="width: 50px;" :src="require('@/assets/image/z9622.png')"></el-image>
    </a>
    <el-image @click="goTop()" fit="cover" style="width: 40px;" :src="require('@/assets/image/z9743.png')"
      class="bootom_right_top"></el-image>

  </div>
</template>

<script>
import deviceAdapter from '@/mixins/deviceAdapter'
import navigationFixed from '@/mixins/navigationFixed'
import Footer from "./compoents/Footer.vue";
import Header from "./compoents/Header.vue";
import { reqGetGoodsList } from '@/api/goods';
export default {
  mixins: [deviceAdapter, navigationFixed],
  components: { Footer, Header },
  name: "PhoneHome",
  data() {
    return {
      showPopover: false,
      actions: [
        { text: '首页' },
        { text: '专业技术' },
        { text: '用户中心' },
        { text: '企业新闻' },
        { text: '名医新作' },
        { text: '听觉名医录' },
        //        { text: '企业新闻板' },
        { text: '关于我们' },
        { text: '下载中心' }
      ],
      showFocus: false,
      scene: 5,
      deviceRow: {},
      price: ''
    };
  },
  created() {
    this.flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (!this.flag) {
      this.$router.push({ name: 'Home' })
    }

    this.doctor_id = this.$route.query.doctor_id;
    this.scene = 5;
    if (this.$store.state.isFinishPay) {
      this.showFocus = true
    }
    // this._getActivity();
    // this.getWechatCode()
    this.getPrice();
  },
  methods: {
    goTop() {
      document.getElementById('top').scrollIntoView({ behavior: "smooth" });
    },
    // 获取价格信息
    async getPrice() {
      let params = {
        pageCurrent: 1,
        pageSize: 1
      };
      let res = await reqGetGoodsList(params)
      if (res.code == 200) {
        this.price = res.data[0].price
      } else {
        this.$message.error(res.message);
      }
    },
    async _getActivity() {
      let param = {
        doctor_id: this.doctor_id || '',
        device_id: 1,
        scene: this.scene || ''
      };
      let res = await getActivity(param);
      if (res.status == 0) {
        this.deviceRow = res.data.deviceRow;
        this.redirect_uri = res.data.redirect_uri;
      }
    },
    isWechat() {
      return (
        String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
        "micromessenger"
      );
    },
    getUrlCode() {
      // 截取url中的code方法
      var url = location.search;
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    getWechatCode() {
      if (this.isWechat()) {
        let local = "https://beta.qingerhuasheng.com/#/phone/confirmOrder";
        this.redirect_uri = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx59c2fecee79635a6&response_type=code&scope=snsapi_userinfo&state=1&redirect_uri=${encodeURIComponent(local)}#wechat_redirect`;
      }
    },

    goPay() {
      if(!this.$store.state.customer.customerInfo.mobile){
        this.$router.push({ 
          name: 'phoneUserLogin' , 
          params:{'scene':1} 
        });
      }else{
        this.$router.push({
          name: 'phoneConfirmOrder', 
          query: { device_id: 5 }  
        })
      }
    },

    goFouces() {
      this.showFocus = false
      this.$store.state.isFinishPay = false
      // 这个暂时弄得蓝湖的
      window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzA3NTE5MTY3MA==#wechat_redirect'
    },
    onCencelFouces() {
      this.showFocus = false
      this.$store.state.isFinishPay = false
    },
    goMeasure() {
      this.$router.push({
        name: 'measurement',
        query: {
          source: 3
        }
      })
    }
  },
};
</script>

<style scoped>
.header {
  width: 100vw;
  height: 8vh;
  background: rgba(255, 255, 255, 1);
  /* position: fixed; */
  top: 0;
  z-index: 20;
  padding: 0 5%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  line-height: 8vh;
}

.logo {
  display: flex;
  font-size: 15px;
}

.logo>.logo_img {
  display: flex;
  margin-right: 1vw;
  flex-direction: column;
  justify-items: center;
  justify-content: center;
}

.logo>img {
  width: 5vw;
  height: 5vh;
  /* line-height: 8vh; */
}

.part1 {
  width: 100%;
  height: 100%;
  background-size: cover !important;
  /* background-repeat: no-repeat; */
  background: url(./image/14.png);
  /* background-attachment: fixed; */
  text-align: center;
}

/* .part11{
  background-size: auto;
  background: url(../../assets/image/phone/H5首页背景.png) no-repeat !important;
} */

.part1_font {
  padding-top: 5vh;

  font-weight: 400;
  font-size: 30px;
}

.part1_img {
  padding-top: 5vh;
}

.part1_font_1 {
  color: #803288;
  font-size: 20px;
  padding: 3vh;
  /* padding-bottom: 1vh */
}

.part1_font_1_1 {
  font-size: 30px;
}

.bugBtn>.van-button {
  width: 25%;
}

.regCode {
  font-size: 10px;

  font-weight: 300;
  line-height: 38px;
  text-align: center;
}

.part2 {
  width: 100vw;
  height: 100vh;
  background-size: cover !important;
  ;
  background: url(./image/15.png);
  text-align: center;
}

.part2_font1 {
  padding-top: 5vh;

  font-weight: 300;
  font-size: 30px;
}

.part2_font2 {
  text-align: left;
  width: 85vw;
  margin: auto;

  padding-top: 5vh;
  font-size: 20px;
}

.part2_font3 {
  padding-top: 3vh;
  font-size: 15px;
  line-height: 3vh;
}



.part3 {
  width: 100vw;
  height: 100vh;
  background-size: cover !important;
  ;
  background: url(./image/16.png);
  text-align: center;
}

.part3_content {
  width: 70vw;
  height: 38vh;
  border-radius: 30px;
  border: 1px #efedf8 solid;
  background-color: rgba(232, 229, 246, 0.6);
  margin: auto;
  margin-top: 1vh;
}

.part3_img {
  width: 60%;
  margin-top: 3%;
}

.part3_font {
  font-size: 10px;
  width: 85%;
  margin: auto;

  text-align: left;
}


.part4 {

  width: 100vw;
  /*height: 120vh;*/
  background-size: cover !important;
  ;
  /*background: url(../../../assets/image/phone/H5产品特点背景@2x.png);*/
  text-align: center;
}


.part41 {

  width: 100vw;
  height: 140vh;
  background-size: cover !important;
  ;
  background: url(./image/17.png);
  text-align: center;
}

.part4_div {
  padding: 2%;
  width: 45vw;
  height: 25vh;
  border-radius: 10px;
  border: 1px #efedf8 solid;
  background-color: rgba(252, 253, 253, 0.6);
  margin: auto;
  margin-top: 2vh;
  display: flex;
  box-sizing: border-box;
}

.part4_item {
  padding: 2%;
  width: 85vw;
  height: 15vh;
  border-radius: 10px;
  border: 1px #efedf8 solid;
  background-color: rgba(252, 253, 253, 0.6);
  box-sizing: border-box;
  margin: auto;
  margin-top: 2vh;
  display: flex;
}

.part4_font {
  flex: 7;
  display: flex;
  justify-items: center;
  justify-content: center;
  flex-direction: column;
  color: #333333;
  margin-left: 5px;
  font-size: 13px;
  text-align: left;
}

.part4_img {
  flex: 3;
  display: flex;
  flex-direction: column;
  justify-items: center;
  justify-content: center;
}


.whiteHeader {
  position: fixed;
  z-index: 20;
  top: 0;
}


.bootom_right {
  position: fixed;
  display: flex;
  flex-direction: column;
  right: 16px;
  bottom: 90px;
  z-index: 10;
  padding: 3px 3px 0 3px;
}


.bootom_right_top {
  position: fixed;
  display: flex;
  flex-direction: column;
  right: 26px;
  bottom: 40px;
  z-index: 10;
}



.part4ContextBox {
  display: flex;
  justify-content: space-between;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 30px;
  padding: 2%;
  margin-top: 10px;
  background-color: rgba(253, 253, 254, 0.8);
  /*margin: 0 10px;*/
}

.part4ContextBox1 {
  width: 100%;
  /*min-height: 180px;*/
  border-radius: 30px;
  background-color: rgba(253, 253, 254, 0.8);
  padding: 2%;
  margin: 0 10px;
  box-sizing: border-box;
}

/*.part4ContextBox {*/

/*width: 100%;*/
/*margin: auto;*/
/*margin-top: 10px;*/
/*display: flex;*/
/*justify-content: space-between;*/
/*}*/

/*.part4ContextBox1 {*/
/*width: 100%;*/
/*height: 180px;*/
/*display: flex;*/
/*justify-content: space-between;*/
/*padding: 2%;*/

/*margin-right: 5px;*/
/*margin-left: 10px;*/
/*border-radius: 10px;*/
/*border: 1px #efedf8 solid;*/
/*background-color: rgba(252, 253, 253, 0.6);*/
/*box-sizing: border-box;*/
/*color: #333333;*/
/*font-size: 13px;*/
/*}*/


/*.part4ContextBox2 {*/
/*width: 100%;*/
/*height: 180px;*/
/*display: flex;*/
/*justify-content: space-between;*/
/*padding: 2%;*/
/*margin-right: 10px;*/
/*margin-left: 5px;*/
/*border-radius: 10px;*/
/*border: 1px #efedf8 solid;*/
/*background-color: rgba(252, 253, 253, 0.6);*/
/*box-sizing: border-box;*/
/*color: #333333;*/
/*font-size: 13px;*/
/*}*/

.part4Font {
  padding: 2px;
  /*height: 100px;*/
  font-size: 14px;
  text-align: left;
}
</style>
